<!-- /**
 * @author Ketan Shetye
 * @created 2025-10-25
 */ -->

<div [ngClass]="data.className" class="common-checkbox-root">
  <label
    *ngIf="data.variant !== 'toggle'"
    [attr.for]="data.name"
    class="checkbox-label"
  >
    <input
      type="checkbox"
      [id]="data.name"
      [name]="data.name"
      [checked]="data.checked"
      [disabled]="disabled"
      (change)="onCheckboxChange($event)"
      (blur)="onTouched()"
      class="checkbox-input"
      [attr.aria-checked]="data.checked"
      [attr.aria-disabled]="disabled"
       [class.on-validation-error]="hasValidationError"
    />

    <span *ngIf="data.showRequiredStar ?? data.required" class="required-star">*</span>
    <span class="label-text">{{ data.label }}</span>
  </label>
  <!-- Added by amisha to handle toggle variant on 6th january 2026 -->

  <label *ngIf="data.variant === 'toggle'" class="toggle-checkbox" style="padding-left: 0px;">
    <input
      type="checkbox"
      [id]="data.name"
      [checked]="data.checked"
      [disabled]="disabled"
      (change)="onCheckboxChange($event)"
      (blur)="onTouched()"
    />

    <span class="toggle-slider"></span>
    <span class="label-text">{{ data.label }}</span>
  </label>
  <!-- end by amisha to handle toggle variant on 6th january 2026 -->
  <div *ngIf="data.helperText" class="helper-text">
    {{ data.helperText }}
  </div>
</div>
